import { DialogProvider } from "@/core/components/ConfirmDialog";
import { LayoutAdmin } from "@/layouts/admin/LayoutAdmin";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin")({
	component: () => (
		<DialogProvider>
			<LayoutAdmin />
		</DialogProvider>
	),
});
